/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description favoritesView actions
 */

import type { Listable, Listables, Pin, Property, RawPinInventorySearch } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import {
  ADD_LIST_ITEM,
  BEGIN_FETCHING_LISTABLES,
  DONE_FETCHING_LISTABLES,
  HIDE,
  RECEIVE_LISTABLES,
  REMOVE_LIST_ITEM,
  RESET,
  SHOW,
} from '../constants/index'

// listables
export const beginFetchingListables = createAction(BEGIN_FETCHING_LISTABLES)
export const doneFetchingListables = createAction(DONE_FETCHING_LISTABLES)
export const receiveListables = createAction<{ listables: Listables }, typeof RECEIVE_LISTABLES>(
  RECEIVE_LISTABLES
)

// view
export const showFavoritesView = createAction(SHOW)
export const hideFavoritesView = createAction(HIDE)

// misc
export const addListItem = createAction<{ entity: Listable }, typeof ADD_LIST_ITEM>(ADD_LIST_ITEM)
export const removeListItem = createAction<
  { entity: Listable | Pin<RawPinInventorySearch> | Property },
  typeof REMOVE_LIST_ITEM
>(REMOVE_LIST_ITEM)
export const resetFavoritesView = createAction(RESET)
